var _path, _path2, _path3, _path4, _path5, _path6, _path7;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgExclusiveBeginner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 80,
    viewBox: "0 0 72 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72 44C72 63.8823 55.8823 80 36 80C16.1177 80 0 63.8823 0 44C0 24.1177 16.1177 8 36 8C55.8823 8 72 24.1177 72 44Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 4C12 1.79086 13.7909 0 16 0H56C58.2091 0 60 1.79086 60 4V56C60 58.2091 58.2091 60 56 60H16C13.7909 60 12 58.2091 12 56V4Z",
    fill: "#C9B3FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 45C20 44.4477 20.4477 44 21 44H51C51.5523 44 52 44.4477 52 45C52 45.5523 51.5523 46 51 46H21C20.4477 46 20 45.5523 20 45Z",
    fill: "#F8F5FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 39C20 38.4477 20.4477 38 21 38H51C51.5523 38 52 38.4477 52 39C52 39.5523 51.5523 40 51 40H21C20.4477 40 20 39.5523 20 39Z",
    fill: "#F8F5FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20 51C20 50.4477 20.4477 50 21 50H41C41.5523 50 42 50.4477 42 51C42 51.5523 41.5523 52 41 52H21C20.4477 52 20 51.5523 20 51Z",
    fill: "#F8F5FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.2803 14.4697C44.5732 14.7626 44.5732 15.2374 44.2803 15.5303L38.8107 21C38.6715 21.1394 38.5061 21.25 38.3241 21.3254C38.1421 21.4009 37.947 21.4398 37.75 21.4398C37.553 21.4398 37.3579 21.4009 37.1759 21.3254C36.9939 21.25 36.8285 21.1394 36.6893 21L34.75 19.0607L28.5303 25.2803C28.2374 25.5732 27.7626 25.5732 27.4697 25.2803C27.1768 24.9874 27.1768 24.5126 27.4697 24.2197L33.6893 18C33.6894 18 33.6894 17.9999 33.6895 17.9999C33.6895 17.9998 33.6896 17.9997 33.6897 17.9997C33.8288 17.8604 33.994 17.75 34.1759 17.6746C34.3579 17.5991 34.553 17.5602 34.75 17.5602C34.947 17.5602 35.1421 17.5991 35.3241 17.6746C35.506 17.75 35.6712 17.8604 35.8103 17.9997C35.8104 17.9997 35.8105 17.9998 35.8105 17.9999C35.8106 17.9999 35.8106 18 35.8107 18L37.75 19.9393L43.2197 14.4697C43.5126 14.1768 43.9874 14.1768 44.2803 14.4697Z",
    fill: "#F8F5FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.25 15C39.25 14.5858 39.5858 14.25 40 14.25H43.75C44.1642 14.25 44.5 14.5858 44.5 15V18.75C44.5 19.1642 44.1642 19.5 43.75 19.5C43.3358 19.5 43 19.1642 43 18.75V15.75H40C39.5858 15.75 39.25 15.4142 39.25 15Z",
    fill: "#F8F5FF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclusiveBeginner);
export default __webpack_public_path__ + "static/media/exclusive-beginner.05646b2bc6e7c9553734cb17ebbb3712.svg";
export { ForwardRef as ReactComponent };